import { createErrorBoundaryForDomain } from 'lib/error/utils/createErrorBoundaryForDomain';

export const ErrorBoundary = createErrorBoundaryForDomain('Global');

const module = {
  ErrorBoundary,
};

export default module;
